"use client"

import type { FunctionComponent, PropsWithChildren } from "react"

import { SkeletonTheme } from "react-loading-skeleton"

import { MAIN_THEME } from "@/modules/Loading/constants/skeleton"

export const InteractivePageContent: FunctionComponent<PropsWithChildren> = ({ children }) => (
  <SkeletonTheme {...MAIN_THEME}>{children}</SkeletonTheme>
)
